// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3687da47","239":"e994b770","732":"ed867595"}[chunkId] + ".chunk.js";
};